import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import NeatCase from "../cases/Neat/neat"

const Neat = () => (
    <Layout>
        <SEO title="Neat | Ryan Luu" />
        <NeatCase />
    </Layout>
)

export default Neat